<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      v-if="!isEditCustomer"
      style="top: 10px"
      @click="toAdd()"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <newCustomerForm
      :dialog="newCustomerDialog"
      @setDialog="newCustomerDialog = $event"
      v-if="!isEditCustomer"
    />
    <editCustomerForm
      :original="originalCustomer"
      :dialog="editCustomerDialog"
      @setDialog="editCustomerDialog = $event"
      :selectedCustomer="selectedCustomer"
      @cancel="cancelEdit()"
      v-if="!isEditCustomer"
    />
    <addressList
      :selectedCustomer="selectedCustomer"
      :dialog="addressListDialog"
      @setDialog="addressListDialog = $event"
      @cancel="cancelEdit()"
    />
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-toolbar dense flat>
          <v-text-field
            v-model="searchFirstName"
            prepend-icon="person"
            label="Search first name"
            single-line
            hide-details
            style="padding: 0"
            @input="
              loadingMessage = true;
              debounceInput();
            "
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 sm6>
        <v-toolbar dense flat>
          <v-text-field
            v-model="searchLastName"
            prepend-icon="person"
            label="Search last name"
            single-line
            hide-details
            style="padding: 0"
            @input="
              loadingMessage = true;
              debounceInput();
            "
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 sm6>
        <v-toolbar dense flat>
          <v-text-field
            prefix="0"
            placeholder="#########"
            v-model="searchTel"
            prepend-icon="phone"
            label="Search tel."
            single-line
            hide-details
            style="padding: 0"
            @input="
              loadingMessage = true;
              debounceInput();
            "
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 sm6>
        <v-toolbar dense flat>
          <v-text-field
            v-model="searchEmail"
            prepend-icon="email"
            label="Search e-mail"
            single-line
            hide-details
            style="padding: 0"
            @input="
              loadingMessage = true;
              debounceInput();
            "
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="customerList"
      :loading="loadingMessage"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" style="font-weight: bold">
          {{ currentPage * pageItems - (pageItems - props.index - 1) }}
        </td>
        <td class="text-xs-center">{{ props.item.user_first_name }}</td>
        <td class="text-xs-center">{{ props.item.user_last_name }}</td>
        <td class="text-xs-center">{{ props.item.user_sum_point }}</td>
        <td class="text-xs-center">{{ props.item.user_email }}</td>
        <td class="text-xs-center">{{ props.item.user_country_tel }}</td>
        <td class="text-xs-center">{{ props.item.user_tel }}</td>
        <td class="text-xs-center" style="color: grey; font-weight: bold">
          {{ props.item.user_id }}
        </td>
        <td class="text-xs-center">{{ typeCheck(props.item) }}</td>
        <td class="text-xs-center">
          {{ moment(props.item.user_create_at).format("YYYY-MM-DD HH:mm น.") }}
        </td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              :loading="fetching_address == props.item.user_id"
              icon
              @click="editAddress(props.item)"
              slot="activator"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-checkbox-otp
            otpTel="974563956"
            v-model="props.item.user_vip"
            @change="setVIP($event, props.item)"
          />
        </td>
        <td
          class="justify-center layou px-0"
          v-if="props.index != indexLoading"
        >
          <v-tooltip top>
            <v-btn
              icon
              :disabled="isEditCustomer"
              @click="editItem(props.item)"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              :disabled="isEditCustomer"
              @click="deleteItem(props.item)"
              slot="activator"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
        <td
          class="justify-center layout px-0"
          v-if="props.index == indexLoading"
        >
          Editing...
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loadingMessage === true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <div style="display: flex; align-items: center; justify-content: center">
      <div style="width: 50vw" class="my-3">
        <v-pagination
          class="mt-3"
          v-model="currentPage"
          :length="totalItems"
          @input="getData()"
        ></v-pagination>
      </div>
    </div>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import newCustomerForm from "./NewCustomerForm.vue";
import editCustomerForm from "./EditCustomerForm.vue";
import addressList from "./AddressList.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  data: () => ({
    search: "",
    errSnackbar: false,
    snackBarMsg: null,
    customerList: [],
    currentPage: 1,
    totalItems: 0,
    pageItems: 20,
    searchFirstName: "",
    searchLastName: "",
    searchTel: "",
    searchEmail: "",
    fetching_address: null,
    originalCustomer: null,
    selectedCustomer: null,
    loadingMessage: false,
    addressListDialog: false,
    newCustomerDialog: false,
    editCustomerDialog: false,
    dialog: false,
    headers: [
      {
        text: "#",
        align: "center",
        sortable: false,
        value: "number",
      },

      {
        text: "First name",
        align: "center",
        value: "user_first_name",
        sortable: false,
      },
      {
        text: "Last name",
        align: "center",
        value: "user_last_name",
        sortable: false,
      },
      {
        text: "Point",
        align: "center",
        value: "user_sum_point",
        sortable: false,
      },

      {
        text: "Email",
        align: "center",
        value: "user_email",
        sortable: false,
      },
      {
        text: "Country code",
        align: "center",
        value: "user_country_tel",
        sortable: false,
      },
      {
        text: "Tel",
        align: "center",
        value: "user_tel",
        sortable: false,
      },
      {
        text: "USER ID",
        align: "center",
        value: "user_id",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "user_type_name_temp",
        sortable: false,
      },
      {
        text: "Join date",
        align: "center",
        value: "user_create_at",
        sortable: false,
      },
      {
        text: "Address",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "VRank",
        align: "center",
        value: "user_sum_point",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
  }),
  components: {
    newCustomerForm,
    editCustomerForm,
    addressList,
  },
  computed: {
    ...mapState({
      customerData: (state) => state.fetchCustomerBack.customerData,
      indexLoading: (state) => state.fetchCustomerBack.indexLoading,
    }),
    ...mapGetters(["isEditCustomer"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  destroyed() {
    this.$store.commit("fetchCustomerBack/resetState");
  },
  created() {
    this.getData();
  },

  methods: {
    ...mapActions({
      setUserToVIP: "fetchUserBack/setUserToVIP",
    }),
    moment,
    debounceInput: _.debounce(function (e) {
      this.currentPage = 1;
      this.getData();
    }, 1000),
    toAdd() {
      this.newCustomerDialog = true;
      this.$store.dispatch("fetchCustomerBack/getProvinceAdd");
    },
    async setVIP(value, item) {
      let result = await this.setUserToVIP({
        user_id: item.user_id,
        user_level_status: value.status,
        otp_pin: value.otp_pin,
        otp_ref: value.otp_ref,
        otp_tel: value.otp_tel,
      });
      if (result === false || result.msg == false) {
        item.user_vip = !item.user_vip;
        this.errSnackbar = true;
        this.snackBarMsg = result.data;
      }
    },
    typeCheck(checkData) {
      if (checkData.user_type == "1") {
        checkData.user_type_name_temp = "Weserve";
      } else if (checkData.user_type == "2") {
        checkData.user_type_name_temp = "Facebook";
      } else {
        checkData.user_type_name_temp = "Other";
      }
      return checkData.user_type_name_temp;
    },
    async editAddress(item) {
      this.selectedCustomer = item;
      this.fetching_address = item.user_id;
      this.selectedCustomer.user_address = await this.$store.dispatch(
        "fetchCustomerBack/getCustomerAddressDetail",
        item.user_id
      );
      this.fetching_address = null;
      this.addressListDialog = true;
      this.$store.dispatch("fetchCustomerBack/getProvinceAdd");
    },
    cancelEdit() {
      this.originalCustomer = null;
      this.selectedCustomer = null;
    },
    editItem(item) {
      this.originalCustomer = Object.assign({}, item);
      this.selectedCustomer = item;
      this.editCustomerDialog = true;
    },
    async deleteItem(item) {
      const index = this.customerData.indexOf(item);

      let check = await confirm("Are you sure you want to delete this user?");
      if (check == false) return;
      let result = await this.$store.dispatch(
        "fetchCustomerBack/deleteCustomer",
        item
      );
      if (result == true) {
        this.getData();
      }
    },
    async getData() {
      this.loadingMessage = true;
      let config = {
        search_first_name: this.searchFirstName,
        search_last_name: this.searchLastName,
        search_tel: this.searchTel,
        search_email: this.searchEmail,
        page_size: this.pageItems,
        current_page: this.currentPage,
      };
      let response = await this.$store.dispatch(
        "fetchCustomerBack/getData",
        config
      );

      this.customerList = response.data;
      this.totalItems = Math.ceil(response.total / this.pageItems);
      this.loadingMessage = false;
    },
  },
};
</script>
